import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";
import Videos from "../Videos";
import Images from "../Images";
import Dropdown from "../Dropdown";
import RightMenu from "../RightMenu";
import AudioPlayer from "react-custom-audio-player";
export default class View_type_8 extends Component {
	constructor(props) {
		super(props);
		//console.log("Artists");
		//console.log("View_type_8: ", props);
		let data = { multimedia: [], prev_dropdown: [], right_menu: [], ...props.data };
		this.state = {
			open: false,
			showPlayButton: true,
			showGalleryPlayButton: false,
			showFullscreenButton: true,
			showGalleryFullscreenButton: false,
			currentImage: 0,
			player: [],
			data: data,
			prevDropdown: data.prev_dropdown,
			audioTrack: {
				id: false,
			},
		};

	}
	playHandler = (event, arg)=> {
		let slectors =document.querySelectorAll('.audio-play-btn');
		slectors.forEach(obj => {
			obj.style.display = 'inline-block'
		});

		event.currentTarget.style.display = 'none';

		this.setState({
			audioTrack:{
				id: arg
			}
		})
	}

	pauseHandler = (event, arg)=> {
		let pauseBtn =document.querySelectorAll('.ivrpausebtn');
		pauseBtn.forEach(obj => {
			obj.addEventListener("click", `console.log("123")`)
		});

	}

	displayAudioTrack = (event, arg) =>{
		event.currentTarget.childNodes[1].style.display = 'block';
		this.setState({
			audioTrack:{
				id: arg
			}
		})
	}

	render() {
		let multimedia = this.state.data.multimedia || [];
		let pageTitle = multimedia.date + " / " + multimedia.title;
		let images = multimedia.images || null;
		let videos = multimedia.videos || null;
	let description = multimedia.description || null;
	let audio = multimedia.audios && multimedia.audios.audio || [];
	var customTitle = 1;


		if (images) {
			images = <Images data={images} />;
		}

		if (videos) {
			videos = <Videos data={videos} />;
		}


	let audios = audio.map((obj, index) => {
		if (obj.mp3!=""){
			return(
				<li
					className="vt8-tracks vt8-audio audios-wrapper"
					key={index}
					onClick={(event)=>{this.displayAudioTrack(event, index)}} >
					<div className="vt8-audio-title-text">
						<div className="vt8-title-audio" dangerouslySetInnerHTML={{ __html: obj.desc }} ></div>
					</div>

					<div className="audios-item">
						{
							this.state.audioTrack.id === index ? <AudioPlayer autoplay={true} src={obj.mp3} controls={true} loop={true} /> : null
						}
					</div>
				</li>
			)
		}
	}) || null;

		return (
			<div className="vt8 container-fluid">
				<div
					className={`
							? "vt8 row vt10--flex-nav"
							: "vt8 row"
					`}
				>
					<div className="vt8 col-xs-12 col-sm-12 col-md-0 col-lg-9">
						<div className="vt8 col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div className="row">
								<div className="vt8 artists-pageTitle col-xs-10 col-sm-10 col-md-10 col-lg-10">
									<p className="h1">{pageTitle}</p>

								</div>
				<div className="vt8 col-xs-10 col-sm-10 col-md-10 col-lg-10">
					 <p className="description" dangerouslySetInnerHTML={{__html: description}}></p>
				</div>

							</div>
						</div>
						<div className="vt8 col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div className="vt8 line" />
						</div>
						<div className="vt8 col-xs-12 col-sm-12 col-md-12 col-lg-12">
							{images}
							{videos}
							<div className="videos title audios">
								<p className="first-title">Muzyka</p>
								<ul className="vt8-audio-list">
									{audios}
								</ul>
							</div>
						</div>
					</div>
					<div
						className={`
								? "vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3 dropdown--nav-flex"
								: "vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3"
						`}
					>
						{this.state.prevDropdown.length ||
						Object.keys(this.state.prevDropdown).length ? (
							<Dropdown
								giveMeClassName={`
										? "festiwal--dropdown"
										: "normal"
								}`}
								data={this.state.prevDropdown}
							/>
						) : null}
						<RightMenu data={this.state.data.right_menu}/>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_8/index.js